module.exports = __webpack_public_path__ + "static/img/h16.7f3a135.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h16.jpg
// module id = 3o74
// module chunks = 0